"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermModuleHelpers = exports.PermModule = void 0;
var PermModule;
(function (PermModule) {
    PermModule["None"] = "None";
    PermModule["KPIGeneral"] = "KPIGeneral";
    PermModule["KPIFinancial"] = "KPIFinancial";
    PermModule["KPIUserAcquisition"] = "KPIUserAcquisition";
    PermModule["Configuration"] = "Configuration";
    PermModule["EconomyInventory"] = "EconomyInventory";
    PermModule["EconomyPackages"] = "EconomyPackages";
    PermModule["EconomyCoupons"] = "EconomyCoupons";
    PermModule["SocialLeaderboards"] = "SocialLeaderboards";
    PermModule["SocialTeams"] = "SocialTeams";
    PermModule["SocialMatches"] = "SocialMatches";
    PermModule["AnalyticsTraits"] = "AnalyticsTraits";
    PermModule["AnalyticsSegmentation"] = "AnalyticsSegmentation";
    PermModule["AnalyticsEventsMapper"] = "AnalyticsEventsMapper";
    PermModule["AnalyticsExperiments"] = "AnalyticsExperiments";
    PermModule["LiveOpsGameEvents"] = "LiveOpsGameEvents";
    PermModule["LiveOpsUserExplorer"] = "LiveOpsUserExplorer";
    PermModule["LiveOpsFlow"] = "LiveOpsFlow";
    PermModule["UserAcquisitionCreativeAssets"] = "UserAcquisitionCreativeAssets";
    PermModule["UserAcquisitionCreativeCopy"] = "UserAcquisitionCreativeCopy";
    PermModule["UserAcquisitionAdministration"] = "UserAcquisitionAdministration";
    PermModule["MachineLearningSynapse"] = "MachineLearningSynapse";
    PermModule["SupportPlayerLookup"] = "SupportPlayerLookup";
    PermModule["SupportPlayerLookupLive"] = "SupportPlayerLookupLive";
    PermModule["SupportPlayerLookupSandbox"] = "SupportPlayerLookupSandbox";
    PermModule["SupportPlayerDelete"] = "SupportPlayerDelete";
    PermModule["SupportLeaderboards"] = "SupportLeaderboards";
    PermModule["SupportTeams"] = "SupportTeams";
    PermModule["SupportMatchMonitoring"] = "SupportMatchMonitoring";
    PermModule["MarketReviews"] = "MarketReviews";
    PermModule["Services"] = "Services";
    PermModule["CloudFunctions"] = "CloudFunctions";
    PermModule["Audiences"] = "Audiences";
    PermModule["AudienceSupport"] = "AudienceSupport";
    PermModule["AudienceRequestsClusterization"] = "AudienceRequestsClusterization";
    PermModule["Scripts"] = "Scripts";
    PermModule["AnalyticsStreaming"] = "AnalyticsStreaming";
    PermModule["DashboardsManagement"] = "DashboardsManagement";
    PermModule["TagsManagement"] = "TagsManagement";
    PermModule["CredentialsManagement"] = "CredentialsManagement";
    PermModule["ApplicationsManagement"] = "ApplicationsManagement";
    PermModule["Integrations"] = "Integrations";
    PermModule["AssetsPolicyConfiguration"] = "AssetsPolicyConfiguration";
    PermModule["InventoryPolicyConfiguration"] = "InventoryPolicyConfiguration";
    PermModule["PackagesPolicyConfiguration"] = "PackagesPolicyConfiguration";
    PermModule["ExperimentsPolicyConfiguration"] = "ExperimentsPolicyConfiguration";
    PermModule["WebEventsConfiguration"] = "WebEventsConfiguration";
    PermModule["Logs"] = "Logs";
})(PermModule = exports.PermModule || (exports.PermModule = {}));
var PermModuleHelpers = (function () {
    function PermModuleHelpers() {
    }
    PermModuleHelpers.isValid = function (value) {
        return PermModuleHelpers.all.indexOf(value) >= 0;
    };
    PermModuleHelpers.all = [
        PermModule.None,
        PermModule.KPIGeneral,
        PermModule.KPIFinancial,
        PermModule.KPIUserAcquisition,
        PermModule.Configuration,
        PermModule.EconomyInventory,
        PermModule.EconomyPackages,
        PermModule.EconomyCoupons,
        PermModule.SocialLeaderboards,
        PermModule.SocialTeams,
        PermModule.SocialMatches,
        PermModule.AnalyticsTraits,
        PermModule.AnalyticsSegmentation,
        PermModule.AnalyticsEventsMapper,
        PermModule.AnalyticsExperiments,
        PermModule.LiveOpsGameEvents,
        PermModule.LiveOpsUserExplorer,
        PermModule.LiveOpsFlow,
        PermModule.UserAcquisitionCreativeAssets,
        PermModule.UserAcquisitionCreativeCopy,
        PermModule.UserAcquisitionAdministration,
        PermModule.MachineLearningSynapse,
        PermModule.SupportPlayerLookup,
        PermModule.SupportPlayerLookupLive,
        PermModule.SupportPlayerLookupSandbox,
        PermModule.SupportPlayerDelete,
        PermModule.SupportLeaderboards,
        PermModule.SupportTeams,
        PermModule.SupportMatchMonitoring,
        PermModule.MarketReviews,
        PermModule.Services,
        PermModule.CloudFunctions,
        PermModule.Audiences,
        PermModule.AudienceSupport,
        PermModule.AudienceRequestsClusterization,
        PermModule.Scripts,
        PermModule.AnalyticsStreaming,
        PermModule.DashboardsManagement,
        PermModule.TagsManagement,
        PermModule.CredentialsManagement,
        PermModule.ApplicationsManagement,
        PermModule.Integrations,
        PermModule.AssetsPolicyConfiguration,
        PermModule.InventoryPolicyConfiguration,
        PermModule.PackagesPolicyConfiguration,
        PermModule.ExperimentsPolicyConfiguration,
        PermModule.WebEventsConfiguration,
        PermModule.Logs
    ];
    return PermModuleHelpers;
}());
exports.PermModuleHelpers = PermModuleHelpers;
var irt_1 = require("@playq/irt");
irt_1.Introspector.register('net.playq.octopus2.auth.PermModule', {
    full: 'net.playq.octopus2.auth.PermModule',
    short: 'PermModule',
    package: 'net.playq.octopus2.auth',
    type: irt_1.IntrospectorTypes.Enum,
    options: PermModuleHelpers.all
});
//# sourceMappingURL=PermModule.js.map